import { render, staticRenderFns } from "./RsaConfigurazioneTipoPrestazioniViewPage.vue?vue&type=template&id=b6b6264a"
import script from "./RsaConfigurazioneTipoPrestazioniViewPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneTipoPrestazioniViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports